import { bl_fi_fixed_asset_category_depreciation_config_RowClass } from '../../../dbschema';
import { BaseContainerModel } from '../../base-container.model';

export class AssetCategoryDepreciationConfigModel extends BaseContainerModel {
  bl_fi_fixed_asset_category_depreciation_config: bl_fi_fixed_asset_category_depreciation_config_RowClass = new bl_fi_fixed_asset_category_depreciation_config_RowClass();
}